import { RoutePaths } from "../RoutePaths";
import type { CarouselSidebar } from "../carousel/CarouselSidebar";

export const PlaylistRoutePaths = {
  CAROUSEL: "carousel",
  BEAMER_VIEW: "beamer-view",
  /** search parameter of the carousel naming the open sidebar */
  SIDEBAR_SEARCH_PARAM: "sidebar",

  // Links
  toCarousel: (playlistIdentifier: string, sidebar?: CarouselSidebar) =>
    `/${RoutePaths.PLAYLIST}/${playlistIdentifier}/${PlaylistRoutePaths.CAROUSEL}` +
    (sidebar ? `?${PlaylistRoutePaths.SIDEBAR_SEARCH_PARAM}=${sidebar}` : ""),
  toBeamerView: (playlistIdentifier: string) =>
    `/${RoutePaths.PLAYLIST}/${playlistIdentifier}/${PlaylistRoutePaths.BEAMER_VIEW}`,
} as const;
